module.exports = __webpack_public_path__ + "img/bilge-pump-on.66941076.svg";